import React from 'react'
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { serverApi, serverApiEurope } from '../lib/utils';
import { LoadingSpinner } from '../components/Common/Loading';

export default class twitterSuccess extends React.Component {
    constructor(props) {
        super(props);
        this.state = { success: false, loading: true };
    }

    componentDidMount() {
        const urlParams = new URLSearchParams(window.location.search);
        console.dir(urlParams);
        const code = urlParams.get('code'); // twitter Token
        const stateParams = urlParams.get('state'); // uid and verifyCode
        console.log(code);
        console.dir(stateParams);
        if (code && stateParams) {
            const stateObjArray = stateParams.split('_'); // JSON.parse(stateParams); 
            console.dir(stateObjArray);
            // // console.dir(JSON.parse(JSON.stringify({provider: 'google', docId: 'ShqOGyyazbudo3Wp4w2b'})));
            const uid = stateObjArray[0];
            const verifyCode = stateObjArray[1];
            // console.log(stateObjArray[0]);
            // console.log(stateObjArray[1]);
            // this.setState({ success: true });
            this.postData(uid, verifyCode, code);
        } else {
            this.setState({ success: false, loading: false });
        }
    }

    async postData(uid, verifyCode, code) {
        try {
            const result = await fetch(`${serverApi}logTwitterToken?t=1`, {
                method: 'POST',
                body: JSON.stringify({ code, uid, verifyCode })
                // headers: {
                //     // "Content-Type": "application/json",
                //     // 'content-type': 'application/x-www-form-urlencoded; charset=utf-8',
                //     // 'Accept': 'application/json, application/xml, text/plain, text/html, *.*'
                //     // 'Authorization': 'Bearer ' + authToken
                // },
            });
            const resultData = await result.json();
            this.setState({ success: resultData.success, loading: false });
        } catch (err) {
            console.dir(err);
            this.setState({ success: false, loading: false });
        }
    }

    render() {
        const { success, loading } = this.state;
        if (loading) {
            return (
                // <LoadingSpinner />
                <div>Loading&hellip;</div>
            )
        }
        return (
            <div>
                {/* <ImportOpml isOPMLPage={true} authToken={authToken} /> */}
                <div style={{ textAlign: 'center', marginTop: '80px', padding: '4em', borderRadius: '24px', boxShadow: '0 20px 40px 0 rgba(0,11,40,.14)' }}>
                    {success && <div> <FontAwesomeIcon style={{ color: 'green', fontSize: '4em' }} icon={'check-circle'} />
                        <h3 style={{ marginTop: '1em' }}>Success</h3>
                        <p>You can now close this and return to the app.</p>
                    </div>}
                    {!success && <div> <FontAwesomeIcon style={{ color: 'red', fontSize: '4em' }} icon={'exclamation-circle'} />
                        <h3 style={{ marginTop: '1em' }}>Error</h3>
                        <p>Please try again.</p>
                    </div>}
                </div>
            </div>
        )
    }
}